import React from 'react'
import { Popup, Icon, Button, Table, Label } from 'semantic-ui-react'
import moment from 'moment'
import firebase from 'firebase/app'

import utils from '../../../utils'

export default class StatusActionsCell extends React.PureComponent {
  state = { canceling: false }

  onCancelPress = async () => {
    try {
      const confirm = window.confirm('Are you sure to cancel express order?')

      if (!confirm) return

      const { order } = this.props
      const orderUid = order.id
      const driverUid = order.deliverer
      const cancelDescription = 'No Reason'
      const cancelKeyCode = 'DEFAULT'

      const params = {
        orderUid,
        driverUid,
        cancelDescription,
        cancelKeyCode,
      }

      this.setState({ canceling: true })

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('expressAction')

      await functions({ actionType: 'canceling-order', ...params })

      this.setState({ canceling: false })
    } catch (error) {
      alert(error.message || error)
      this.setState({ canceling: false })
    }
  }

  render() {
    const { canceling } = this.state
    const { status, updatedAt, readOnly, courierType } = this.props
    const isCancelAble = ['outForDelivery', 'confirmed'].includes(status)

    return (
      <Table.Cell>
        <div style={{ textAlign: 'center' }}>
          <div>
            <Label
              size="large"
              color="blue"
              style={{ width: 150, margin: '0px 0px 5px 0px' }}
            >
              {utils.helpers.getExpressCourierType(courierType)}
            </Label>
          </div>

          <Popup
            trigger={
              <Label
                size="large"
                color={utils.helpers.getOrderStatus(status).color}
                style={{ width: 150, margin: 0 }}
              >
                {utils.helpers.getOrderStatus(status).label}
              </Label>
            }
            position="top center"
          >
            {updatedAt ? (
              <div style={{ textAlign: 'center' }}>
                {moment(updatedAt).format('HH:mm a')}
                <br />
                {moment(updatedAt).format('DD-MMM-YYYY')}
              </div>
            ) : (
              'N/A'
            )}
          </Popup>

          {isCancelAble && !readOnly ? (
            <div>
              <Button
                size="mini"
                style={{ width: 150, margin: '5px 0px 0px 0px' }}
                loading={canceling}
                disabled={canceling}
                onClick={this.onCancelPress}
              >
                <Icon name="cancel" />
                Cancel Order
              </Button>
            </div>
          ) : null}
        </div>
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/express/components/StatusActionsCell.js